import React from "react";
import Button from "@components/buttons/Button/Button";
import PopupCard from "@components/modals/PopupCard/PopupCard";
import styles from "./ChooseMemorialTypePopup.module.css";

interface ChooseMemorialTypePopupProps {
    visible: boolean;
    onClose: () => void;
    onSelect: (type: "human" | "pet") => void;
}

const ChooseMemorialTypePopup: React.FC<ChooseMemorialTypePopupProps> = ({ visible, onClose, onSelect }) => {
    return (
        <PopupCard visible={visible} onClose={onClose}>
            <div className={styles.container}>
                <h2 className={styles.title}>Create Forever Memorial</h2>
                <p className={styles.subtitle}>Please choose the type of memorial you want to create</p>

                <div className={styles.buttonGroup}>
                    <Button
                        variant="primary"
                        size="large"
                        onClick={() => onSelect("human")}
                    >
                        Traditional Memorial
                    </Button>
                    <Button
                        variant="secondary"
                        size="large"
                        onClick={() => onSelect("pet")}
                    >
                        Pet Memorial
                    </Button>
                </div>

                <button className={styles.closeButton} onClick={onClose}>
                    Cancel
                </button>
            </div>
        </PopupCard>
    );
};

export default ChooseMemorialTypePopup;
